module.exports = __webpack_public_path__ + "img/ryzhkov_oleksandr.e6fdb41f.png";